import { useRecoilValue } from 'recoil';
import { blockDisplayHeader, customizedBlock } from 'venn-state';
import { BenchmarkType } from '../../components/secondary/benchmark-type';
import { DefaultSubjects } from '../../components/secondary/subjects/default-subjects';
import React from 'react';
import { Block } from '../../components/core';

export const GrowthSimulationHeader = ({ id }: { id: string }) => {
  const title = useRecoilValue(blockDisplayHeader(id));
  const { selectedMetrics, relativeToBenchmark, subHeader } = useRecoilValue(customizedBlock(id));

  return (
    <>
      <Block.HeaderTopContainer id={id}>
        <Block.Title>
          <Block.Headline id={id}>{title}</Block.Headline>
          {subHeader && <Block.SubHeadline id={id}>{subHeader}</Block.SubHeadline>}
        </Block.Title>

        <Block.Metadata id={id}>
          <BenchmarkType id={id} />
        </Block.Metadata>
      </Block.HeaderTopContainer>

      <DefaultSubjects id={id} metric={selectedMetrics[0]! || ''} relativeToBenchmark={relativeToBenchmark} />
    </>
  );
};
